/***************************************************************************************************
 * Load `$localize` onto the global scope.
 */
import '@angular/localize/init';


/***************************************************************************************************
 * BROWSER POLYFILLS
 *
 * BillSoft browser support:
 * - Windows 7 + Chrome 109
 * - Windows 10/11 + latest Chrome
 * - macOS + supported Chrome/Safari
 *
 * NOTE:
 * Chrome 109 already supports the standard APIs required here.
 * IE11 is NOT supported.
 */


/***************************************************************************************************
 * Zone JS
 *
 * Zone.js is required by Angular.
 */
import 'zone.js';


/***************************************************************************************************
 * APPLICATION IMPORTS
 *
 * Add application-wide polyfills/imports below this section only when required.
 */